"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUESTED_STAFF_DEEP_LINK_ORIGIN = exports.REQUESTED_STAFF_URL_PARAM_NAME = exports.REQUESTED_CATEGORIES_URL_PARAM_NAME = void 0;
exports.REQUESTED_CATEGORIES_URL_PARAM_NAME = 'category';
exports.REQUESTED_STAFF_URL_PARAM_NAME = 'staff';
exports.REQUESTED_STAFF_DEEP_LINK_ORIGIN = 'staff_widget';
//# sourceMappingURL=constant.js.map